import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  UrlTree,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const allowedRoles = route.data['roles'] as string[] | undefined;
    const userRole = localStorage.getItem('role');

    if (!userRole) {
      return this.router.createUrlTree(['/login']);
    }

    if (!allowedRoles || allowedRoles.includes(userRole)) {
      return true;
    }

    return this.router.createUrlTree(['/forbidden']);
  }
}
